__webpack_require__.p = "https://skillcore.io/packs/";